import React, { Component } from 'react';
import $ from "jquery";
import {  Link } from 'react-router-dom';
import phone from './si-glyph-call.svg';
import fax from './si-glyph-phone-fax.svg';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card borderNone">
                          <div className="card-body">
                            <h5 className="card-title">Steuerberatungskanzlei R. Heckmann</h5>
                            <h6 className="card-subtitle mb-2 text-muted">D&uuml;sseldorf</h6>
                            <p className="card-text">
                                Steuerberatungskanzlei
                                <br />
                                Dipl.-&Ouml;konom, Dipl.-Finanzwirt
                                <br />
                                R&uuml;diger Heckmann
                                <br />
                                <br />
                                Vereidigter Buchpr&uuml;fer und Steuerberater
                                <br />
                                <br />
                                Inselstraße 11
                                <br />
                                D 40479 D&uuml;sseldorf
                                <br />
                                <br />
                                <img src={phone} alt="Anrufen" className="phone" title="Telefon"></img> <a className="colorBlack" href="tel:+492115370700">0211 53 70 700</a>
                                <br />
                                <img src={fax} alt="Fax" className="phone" title="Fax"></img> 0211 53 70 773
                            </p>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/Home.js